import { ulid } from 'ulid';
const slug = require('slug');

export function nameToSlug(name) {
  return slug(String(name).toString());
}

export function nameAndIdToUrl(id, name, preFix = "p") {
  return nameToSlug(name) + "-" + preFix + id + ".html";
}

export function urlToId(url, preFix = "p") {
  if (url) {
    let str = url.split('-').slice(-1).pop();
    if (str) {
      return str.replace(preFix, "").replace(".html", "");
    }
  }
  return false;
}

export function urlToSlug(url) {
  if (url) {
    let str = url.split('/').slice(-1).pop();
    return str.substr(0, str.lastIndexOf(`-`));
  }
  return "";
}

export function genUUID(length = 8) {
  var result = '';
  var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  var charactersLength = characters.length;
  for (var i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() *
      charactersLength));
  }
  return result;
}

export function genULID() {
  return ulid();
}

const SOURCE_NUM = ["e", "2", "w", "R", "o", "1", "n", "3", "j", "l"];
export function encodeTime(num) {
  const str = num.toString();
  let result = "";
  for (var i = 0; i < str.length; i++) {
    result += SOURCE_NUM[+str[i]];
  }
  return result;
}

export function genUidTime(uid) {
  return uid + encodeTime(Math.round(Date.now() / 1000) * 4 + 2);
}